(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeSummaryOperationalTasksController', Controller);

    Controller.$inject = ['$scope', '$state', '$modal', 'employeeProfileService', 'eventService','selfAccessRequestService'];

    function Controller($scope, $state, $modal, employeeProfileService, eventService, selfAccessRequestService) {
        
        // Verify if we can create adhoc request or one is already active
        $scope.selfAccRequestEmpStatus = {};
        selfAccessRequestService
            .getAdHocSelfAccessRequestStatus($scope.employee.ActiveDirectoryAccountUsername)
            .then(function (status) {
                $scope.selfAccRequestEmpStatus = status;
            });      

        // Get all Self Access Requests
        selfAccessRequestService
            .getSelfAccessRequestsWithoutOwnerForEmployee($scope.employee.EmployeeID)
            .then(function (requests) {
                $scope.selfAccessRequestsWithoutOwnerForEmployee = requests
            });

        // With Self Access Request Without Owner For Employee?
        $scope.withSelfAccessRequestsWithoutOwnerForEmployee = function () {
            return _.size($scope.selfAccessRequestsWithoutOwnerForEmployee) > 0;
        }
        
        // Create Ad-Hod Request
        $scope.createAdHocSelfAccessRequest = function () {
            if (_.isUndefined($scope.selfAccRequestEmpStatus)) return;
            if (!$scope.selfAccRequestEmpStatus.CanCreateAdHocRequest) return;
            if ($scope.selfAccRequestEmpStatus.isCreateingAdHoc) return;

            $scope.selfAccRequestEmpStatus.isCreateingAdHoc = true;

            selfAccessRequestService
                       .createAdHocSelfAccessRequest($scope.employee.EmployeeID)
                       .then(function (req) {
                           $state.go(req.SelfRequestPageRoute, {
                               userAccessRequestId: req.UserAccessRequestID
                           });
                       });
        }

        // Show IT Operational Tasks?
        $scope.showITOperationalTasks = function () {
            if (_.isUndefined($scope.authenticatedUser)) return false;

            if ($scope.authenticatedUser.IsInAdministrationGroup) return true;
            if ($scope.authenticatedUser.IsInAdministrativeServicesGroup) return true;
            if ($scope.authenticatedUser.IsInITServiceDeskGroup) return true;
            if ($scope.authenticatedUser.IsInHRGroup) return true;

            return ($scope.authenticatedUser.IsInITOperationsGroup || $scope.authenticatedUser.IsInBTGAccessManagementGroup);
        };
    }
})();